import styles from '@/styles/productDetail/productReviews.module.scss'

// 统计图表
export default function Chart({ reviewCount, reviewSummary, usageType }: { reviewCount: number, reviewSummary: any, usageType?: string }) {

  function calculateParcent(num: number) {
    const value = (Math.round(num / reviewCount * 10000) / 100 || '0')
    const parcent = value > 100 ? "100%" : (value + "%")
    return parcent
  }

  return (
    <div className={styles['chart']}>
      {
        [5, 4, 3, 2, 1].map((index: number) => {
          const num = reviewSummary[`rating${index}`]
          const parcent = calculateParcent(num)
          return (
            <div className={styles['reviews-item']} key={index}>
              <span className={styles['rate']}>{index}</span>
              <div className={styles['line']}>
                <div className={styles['value']} style={{ width: parcent }}></div>
              </div>
              <span className={styles['percent']}>{usageType == "quantity" ? num : parcent}</span>
            </div>
          )
        })
      }
    </div>
  )
}